/* Silvienne landing behaviour */
const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
const ls = {
  get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
  set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
};
const once = (el, key) => { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; };

/* Countdown */
function countdown(root) {
  if (!once(root, 'mmCd')) return;
  const mode = root.dataset.mode, hours = Number(root.dataset.hours) || 6;
  const [h, m, s] = ['.hours', '.minutes', '.seconds'].map((c) => root.querySelector(c));
  const end = () => {
    const now = Date.now();
    if (mode === 'midnight') { const d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime(); }
    if (mode === 'date') { const t = Date.parse(root.dataset.end); if (!isNaN(t)) return t; }
    const key = 'mm-cd-' + hours; let e = Number(ls.get(key));
    if (!e || e <= now) { e = now + hours * 3600000; ls.set(key, String(e)); }
    return e;
  };
  let e = end();
  const tick = () => {
    let d = Math.floor((e - Date.now()) / 1000);
    if (d <= 0) { if (mode === 'date') d = 0; else { e = end(); d = Math.floor((e - Date.now()) / 1000); } }
    h.textContent = pad(Math.floor(d / 3600)); m.textContent = pad(Math.floor((d % 3600) / 60)); s.textContent = pad(d % 60);
  };
  tick(); setInterval(tick, 1000);
}

/* Gallery */
function gallery(root) {
  if (!once(root, 'mmGal')) return;
  const slides = [...root.querySelectorAll('.shop-image-zoom-wrapper')];
  const thumbs = [...root.querySelectorAll('.shop-thumbnail')];
  let i = 0;
  const go = (n) => {
    i = (n + slides.length) % slides.length;
    slides.forEach((s, k) => { s.classList.toggle('active', k === i); s.querySelector('.shop-main-image')?.classList.toggle('active', k === i); });
    thumbs.forEach((t, k) => t.classList.toggle('active', k === i));
  };
  thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
  go(0);
  let x0 = null;
  const box = root.querySelector('.shop-image-container');
  box?.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
  box?.addEventListener('touchend', (e) => {
    if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null;
    if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
  });
}

/* Product: bundles, subscription, add to cart */
function product(root) {
  if (!once(root, 'mmProd')) return;
  const form = root.querySelector('[data-mm-form]');
  if (!form) return;
  const idInput = form.querySelector('[data-variant-input]');
  const planInput = form.querySelector('[data-plan-input]');
  const bars = [...root.querySelectorAll('.kaching-bundles__bar[data-variant]')];
  const sub = root.querySelector('[data-plan-toggle]');
  const buy = root.querySelector('[data-mm-buy]');
  const err = root.querySelector('[data-mm-error]');
  let variants = [];
  try { variants = JSON.parse(root.querySelector('[data-mm-variants]').textContent); } catch (e) {}
  const byId = (id) => variants.find((v) => String(v.id) === String(id));

  const prices = () => {
    const plan = sub && sub.getAttribute('aria-checked') === 'true' ? sub.dataset.plan : null;
    bars.forEach((b) => {
      const v = byId(b.dataset.variant), el = b.querySelector('[data-price]');
      if (v && el) el.textContent = plan && v.plans[plan] ? v.plans[plan] : v.price;
    });
    planInput.value = plan || ''; planInput.disabled = !plan;
  };
  const select = (bar, push) => {
    if (!bar) return;
    bars.forEach((b) => b.classList.toggle('kaching-bundles__bar--selected', b === bar));
    idInput.value = bar.dataset.variant;
    const v = byId(bar.dataset.variant); if (buy && v) buy.disabled = !v.available;
    if (push) { const u = new URL(location.href); u.searchParams.set('variant', bar.dataset.variant); history.replaceState(history.state, '', u); }
  };
  bars.forEach((b) => {
    b.addEventListener('click', (e) => { e.preventDefault(); select(b, true); });
    b.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(b, true); } });
  });
  if (sub) {
    const flip = () => { sub.setAttribute('aria-checked', sub.getAttribute('aria-checked') === 'true' ? 'false' : 'true'); prices(); };
    sub.addEventListener('click', flip);
    sub.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } });
  }
  const urlV = new URLSearchParams(location.search).get('variant');
  select(bars.find((b) => b.dataset.variant === urlV) || bars.find((b) => b.dataset.default === 'true') || bars[0], false);
  prices();

  buy?.addEventListener('click', async () => {
    const mode = form.dataset.after;
    if (mode !== 'drawer') { form.submit(); return; }
    if (err) err.hidden = true;
    buy.setAttribute('aria-busy', 'true');
    try {
      if (window.MMCart) {
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: new FormData(form) });
        const data = await res.json();
        if (!res.ok || data.status) { if (err) { err.textContent = data.description || data.message || 'Could not add to cart'; err.hidden = false; } return; }
        window.MMCart.open(); return;
      }
      const fd = new FormData(form);
      const ids = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
      if (ids.length) fd.append('sections', ids.join(','));
      let Ev = null; try { Ev = await import('@shopify/events'); } catch (e) {}
      const def = Ev && Ev.CartLinesUpdateEvent.createPromise ? Ev.CartLinesUpdateEvent.createPromise() : null;
      if (def) form.dispatchEvent(new Ev.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(fd.get('id')), quantity: 1 }], promise: def.promise }));
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd });
      const data = await res.json();
      if (!res.ok || data.status) {
        if (def) def.resolve({ cart: null, detail: { didError: true } });
        if (err) { err.textContent = data.description || data.message || 'Could not add to cart'; err.hidden = false; }
        return;
      }
      const cart = await fetch('/cart.js').then((r) => r.json());
      updateCount(cart.item_count);
      const drawer = document.querySelector('cart-drawer-component');
      if (def && drawer) {
        def.resolve({ cart: Ev.CartLinesUpdateEvent.createCartFromAjaxResponse ? Ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart) : cart, detail: { items: cart.items, source: 'mm-product', sourceId: 'mm', itemCount: 1, sections: data.sections, didError: false } });
        setTimeout(() => { const d = drawer.querySelector('dialog'); if (!(d && d.open) && typeof drawer.open === 'function') drawer.open(); }, 350);
      } else location.href = '/cart';
    } catch (e) { console.error(e); form.submit(); }
    finally { buy.removeAttribute('aria-busy'); }
  });
}

/* Cart icon */
function updateCount(n) {
  document.querySelectorAll('[data-mm-cart-count]').forEach((b) => { b.hidden = !n; b.querySelector('span').textContent = n; });
}
function cartIcon(a) {
  if (!once(a, 'mmCart')) return;
  a.addEventListener('click', (e) => {
    if (window.MMCart) { e.preventDefault(); window.MMCart.open(); return; }
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') { e.preventDefault(); drawer.open(); }
  });
}
document.addEventListener('cart:update', () => fetch('/cart.js').then((r) => r.json()).then((c) => updateCount(c.item_count)).catch(() => {}));
document.addEventListener('shopify:cart-lines-update', () => setTimeout(() => fetch('/cart.js').then((r) => r.json()).then((c) => updateCount(c.item_count)).catch(() => {}), 600));

/* Accordions (product + FAQ) */
function accordions(scope) {
  scope.querySelectorAll('.mm .faq-item').forEach((item) => {
    if (!once(item, 'mmAcc')) return;
    const q = item.querySelector('.faq-question'), a = item.querySelector('.faq-answer');
    const toggle = () => {
      const open = !item.classList.contains('active');
      const group = item.parentElement;
      if (group && group.closest('[data-accordion="true"]')) group.querySelectorAll('.faq-item.active').forEach((o) => { if (o !== item) { o.classList.remove('active'); const oa = o.querySelector('.faq-answer'); if (oa) oa.style.maxHeight = null; } });
      item.classList.toggle('active', open);
      q?.setAttribute('aria-expanded', open);
      if (a) { a.setAttribute('aria-hidden', !open); a.style.maxHeight = open ? a.scrollHeight + 40 + 'px' : null; }
    };
    q?.addEventListener('click', toggle);
    q?.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
  });
}

/* Roadmap timeline */
function roadmap(root) {
  if (!once(root, 'mmRm')) return;
  const items = [...root.querySelectorAll('.roadmap-item')];
  const tl = root.querySelector('.roadmap-timeline'), fill = root.querySelector('.timeline-fill');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { en.target.classList.remove('fade-out'); en.target.classList.add('animate-in'); io.unobserve(en.target); } }), { threshold: 0.2 });
    items.forEach((i) => io.observe(i));
  } else items.forEach((i) => i.classList.remove('fade-out'));
  const onScroll = () => {
    if (!tl || !fill) return;
    const r = tl.getBoundingClientRect(), vh = innerHeight;
    const p = Math.min(1, Math.max(0, (vh * 0.6 - r.top) / r.height));
    fill.style.height = (p * 100) + '%';
  };
  addEventListener('scroll', onScroll, { passive: true }); onScroll();
}

/* Counters */
function counters(scope) {
  const els = [...scope.querySelectorAll('.mm .counter-animate')].filter((e) => once(e, 'mmCnt'));
  const run = (el) => {
    const t = Number(el.dataset.target) || 0, suf = el.dataset.suffix || '', dur = Number(el.dataset.duration) || 2000, t0 = performance.now();
    const step = (now) => { const p = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(t * e) + suf; if (p < 1) requestAnimationFrame(step); else el.classList.add('animated'); };
    requestAnimationFrame(step);
  };
  if (!('IntersectionObserver' in window)) { els.forEach((el) => (el.textContent = el.dataset.target + (el.dataset.suffix || ''))); return; }
  const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { io.unobserve(en.target); setTimeout(() => run(en.target), 200); } }), { threshold: 0.3 });
  els.forEach((el) => io.observe(el));
}

/* Reviews carousel */
function reviews(root) {
  if (!once(root, 'mmRv')) return;
  const c = root.querySelector('.reviews-container');
  const step = () => (c.querySelector('.review-card')?.getBoundingClientRect().width || 360) + 20;
  root.querySelector('[data-prev]')?.addEventListener('click', () => c.scrollBy({ left: -step(), behavior: 'smooth' }));
  root.querySelector('[data-next]')?.addEventListener('click', () => c.scrollBy({ left: step(), behavior: 'smooth' }));
}

/* Video modal */
function videos(root) {
  if (!once(root, 'mmVid')) return;
  const modal = root.querySelector('[data-mm-modal]');
  if (!modal) return;
  const box = modal.querySelector('.video-container');
  const close = () => { modal.style.display = 'none'; box.innerHTML = ''; document.body.style.overflow = ''; };
  root.querySelectorAll('[data-mm-video]').forEach((item) => {
    const tpl = item.querySelector('template[data-mm-video-src]');
    if (!tpl) return;
    item.style.cursor = 'pointer';
    item.addEventListener('click', () => {
      const holder = item.querySelector('.shopify-video-container') || item;
      holder.replaceChildren(tpl.content.cloneNode(true));
      item.querySelector('.video-play-overlay')?.remove();
      item.querySelector('.gradient-overlay')?.remove();
      const v = holder.querySelector('video');
      if (v) {
        v.setAttribute('playsinline', '');
        v.controls = true;
        Object.assign(v.style, { width: '100%', height: '100%', objectFit: 'cover' });
        v.play().catch(() => {});
      }
    }, { once: true });
  });
  modal.querySelector('.close-modal')?.addEventListener('click', close);
  modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
  addEventListener('keydown', (e) => { if (e.key === 'Escape' && modal.style.display !== 'none') close(); });
}

/* Header drawer */
function drawer(d) {
  if (!once(d, 'mmDr')) return;
  const sum = d.querySelector('summary');
  sum.addEventListener('click', (e) => {
    e.preventDefault();
    if (d.open) { d.classList.remove('menu-opening'); setTimeout(() => d.removeAttribute('open'), 250); document.body.style.overflow = ''; }
    else { d.setAttribute('open', ''); requestAnimationFrame(() => d.classList.add('menu-opening')); document.body.style.overflow = 'hidden'; }
  });
}

/* Country selector */
function disclosure(root) {
  if (!once(root, 'mmDis')) return;
  const btn = root.querySelector('.disclosure__button'), list = root.querySelector('.disclosure__list-wrapper');
  const form = root.closest('form');
  btn.addEventListener('click', () => { const open = list.hidden; list.hidden = !open; btn.setAttribute('aria-expanded', open); });
  root.querySelectorAll('a[data-value]').forEach((a) => a.addEventListener('click', (e) => {
    e.preventDefault(); form.querySelector('input[name="country_code"]').value = a.dataset.value; form.submit();
  }));
  document.addEventListener('click', (e) => { if (!root.contains(e.target)) { list.hidden = true; btn.setAttribute('aria-expanded', false); } });
}

function init(scope = document) {
  scope.querySelectorAll('[data-mm-countdown]').forEach(countdown);
  scope.querySelectorAll('[data-mm-gallery]').forEach(gallery);
  scope.querySelectorAll('[data-mm-product]').forEach((r) => { product(r); videos(r); });
  scope.querySelectorAll('[data-mm-cart-icon]').forEach(cartIcon);
  scope.querySelectorAll('[data-mm-roadmap]').forEach(roadmap);
  scope.querySelectorAll('[data-mm-reviews]').forEach(reviews);
  scope.querySelectorAll('[data-mm-drawer]').forEach(drawer);
  scope.querySelectorAll('[data-mm-disclosure]').forEach(disclosure);
  accordions(scope); counters(scope);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
document.addEventListener('shopify:section:load', (e) => init(e.target));
